import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import detectingMobileDevice from './detectingMobileDevice';
import styled from 'styled-components';
/*
*  @description Component
*  Gestion des select rendu différent pour les mobiles,
*  afin d'optimiser l'intégration
*/

const SubTitle = styled.div`
  font-size: 0.8em;
  color: #484848;
`

const RenderSelectFieldCommand = ({ items, input, label, meta, helperText, classes, style, id, dataCy, placeHolder}) => {
  let displayError = meta.submitFailed && meta.error ? true : false;
  let getSubTitle = (items ) => {
    if (items.length === 1) {
      return (
        <SubTitle> {items[0].quantity} {items[0].description} {items[0].color} {items[0].size} </SubTitle>
      )
    } else {
      return (
        <SubTitle>
          {items[0].quantity} {items[0].description} {items[0].color} {items[0].size}
          <br/>
          {items[1].quantity} {items[1].description} {items[1].color} {items[1].size}
        </SubTitle>
      )
    }
  }
  if (detectingMobileDevice) {
    return (
      <FormControl error={displayError} style={style}>
        <InputLabel>{label}</InputLabel>
        <NativeSelect {...input} id={id}>
          <option value="" disabled>
            { placeHolder ? placeHolder : ''}
          </option>
          {
            items.map((item, index) => {
              return <option key={index} value={item.code || item.id} data-cy={`menu-item-${dataCy}-${index}`}>
                {
                  item.color && item.size ?
                  `${item.name} ${item.color} / ${item.size}`
                  :
                  item.name
                }
              </option>
            })
          }
        </NativeSelect>
        <FormHelperText>{displayError ? meta.error : null}</FormHelperText>
      </FormControl>
    )
  } else {
    return (
      <FormControl style={style} error={displayError}>
        <InputLabel>
          {label}
        </InputLabel>
        <Select {...input}
                displayEmpty
                error={displayError}
                data-cy={`select-${dataCy}`}>
                <MenuItem value="" disabled>
                  { placeHolder ? placeHolder : ''}
                </MenuItem>
          {
            items.map((item, index) => {
              return <MenuItem key={index} value={item.code || item.id} data-cy={`menu-item-${dataCy}-${index}`} style={{paddingTop: 35, paddingBottom: 35}}>
                      {
                        <div>
                          {
                            item.name
                          }
                          {
                            getSubTitle(item.items)
                          }
                        </div>
                      }
                    </MenuItem>
            })
          }
        </Select>
        <FormHelperText>{ displayError ? meta.error : null }</FormHelperText>
      </FormControl>
      )
    }
  }

export default RenderSelectFieldCommand;
